/**
 * flag-icons CSS is non-critical for first paint (phone country flags only).
 * Dynamic import keeps it out of the initial CSS bundle; delay matches other deferred widgets.
 */
export default defineNuxtPlugin(() => {
  const delayMs = 3000
  window.setTimeout(() => {
    void import('flag-icons/css/flag-icons.min.css')
  }, delayMs)
})
